import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { Link } from "react-router-dom";
import { getPrincipalMessage } from "../Service/Api";

function ManagementData() {
  const [managementData, setManagementData] = useState([]);
  const { pathname } = useLocation();
  const getCategoryFromPath = (path) => {
    const slug = path.replace("/", "").replace("-message", ""); // "vice-principal"
    return slug
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" "); // "Vice Principal"
  };

  const category = getCategoryFromPath(pathname);

  useEffect(() => {
    const fetchManagementData = async () => {
      try {
        const response = await getPrincipalMessage();
        setManagementData(response);
      } catch (error) {
        console.error("Error fetching management data", error);
      }
    };
    fetchManagementData();
  }, []);

  const order = ["President", "Manager", "Principal", "Vice Principal"];

  return (
    <>
      <div className="row management-column">
        {order.map((category) => {
          const person = managementData.find(
            (item) => item.category?.toLowerCase() === category.toLowerCase(),
          );

          if (!person) return null;

          return (
            <div
              key={person._id || category}
              className="col-lg-3 col-md-6 col-sm-6 col-6 full-width"
            >
              <Link
                to={`/${category.toLowerCase().replace(/\s+/g, "-")}-message`}
              >
                <div className="management-list">
                  <img
                    src={
                      person.attachments && person.attachments.length > 0
                        ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${person.attachments[0]}`
                        : ""
                    }
                    className="img-fluid"
                    alt={person.name}
                  />

                  <p>{person.name}</p>
                  <p>
                    <span>
                      {category.toLowerCase() === "president"
                        ? "patron of the school"
                        : person.category}
                    </span>
                  </p>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default ManagementData;
